import React from "react";
import PropTypes from 'prop-types';
import { Typography } from '../../index';
import SelectGroup from './SelectGroup'
import './radio.scss';

export const Radio = ({label, handleOnclick, selected, disabled, variant = 'primary', index, optionsLength }) => {
    const checkSelected = label === selected;
    return (variant === 'select'
        ? <SelectGroup
            label={label}
            selected={selected}
            handleOnclick={handleOnclick}
            disabled={false}
            index={index}
            optionsLength={optionsLength}
        />
        : <label className={`radio-container ${checkSelected ? "selected-container" : ""}`}>
            <Typography type="body-02">
                {label}
            </Typography>
            <input
                type="radio"
                name={name}
                value={label}
                checked={checkSelected}
                onChange={handleOnclick}
                disabled={false}
            />
            <span className="checkmark" />
        </label>
    );
};
